import { getEvent } from "../sanity/client";
import SlugPage from "../components/slugPage";
import { Link, useParams } from "react-router-dom";
import useSWR from "swr";

export default function Event() {
  const { slug } = useParams();
  const { data: content } = useSWR(
    slug ? `class-${slug}` : null,
    () => getEvent(slug!).then((r) => r[0])
  );

  return (
    <>
      <Link to="/classes">&lt; Back to all classes</Link>
      {content && <SlugPage columned content={content} />}
    </>
  );
}
